var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"45f49ed81637bb16e1674c7be43352bb6e9572b4"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// sentry.client.config.js (or .ts)
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://c1f7497fa40640a9857e04886a919f35@o4504588448890880.ingest.sentry.io/4504815602696192',

  tracesSampleRate: 1,
  debug: false,

  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.2,

  beforeBreadcrumb(breadcrumb) {
    try {
      const url = String(breadcrumb?.data?.url || '');

      // Existing chatbot breadcrumb filter
      if (url.includes('api-v2.24hrdoc.com/chatbot/')) return null;

      // Optional: also remove Lucky Orange request breadcrumbs
      if (url.includes('settings.luckyorange.net')) return null;
    } catch (e) {}

    return breadcrumb;
  },

  beforeSend(event, hint) {
    try {
      // Intentional throw from _app.js to abort Next.js client-side navigation
      // when forcing a hard reload into a route with different tracking rules.
      const raw = hint?.originalException;
      if (typeof raw === 'string' && raw.includes('routeChange aborted')) return null;

      const ex = event?.exception?.values?.[0];
      const type = String(ex?.type || '');
      const value = String(ex?.value || '').toLowerCase();
      const message = String(event?.message || '').toLowerCase();

      const isNetworkStyleError =
        (type === 'TypeError' && value.includes('load failed')) ||
        value.includes('network error') ||
        message.includes('network error');

      const urls = new Set();

      const requestUrl = String(event?.request?.url || '');
      if (requestUrl) urls.add(requestUrl);

      for (const c of event?.breadcrumbs || []) {
        const url = String(c?.data?.url || '');
        if (url) urls.add(url);
      }

      for (const frame of ex?.stacktrace?.frames || []) {
        const filename = String(frame?.filename || '');
        if (filename) urls.add(filename);
      }

      const hasChatbotRequest = [...urls].some((url) =>
        url.includes('api-v2.24hrdoc.com/chatbot/')
      );

      const hasLuckyOrangeRequest = [...urls].some((url) =>
        url.includes('settings.luckyorange.net')
      );

      if (isNetworkStyleError && hasChatbotRequest) return null;
      if (isNetworkStyleError && hasLuckyOrangeRequest) return null;
    } catch (e) {}

    return event;
  },

  beforeSendTransaction(event) {
    try {
      const spans = event?.spans || [];

      const hasLuckyOrangeSpan = spans.some((span) => {
        const url =
          String(span?.data?.url || '') ||
          String(span?.data?.['http.url'] || '') ||
          String(span?.description || '');

        return url.includes('settings.luckyorange.net');
      });

      if (hasLuckyOrangeSpan) {
        return null;
      }
    } catch (e) {}

    return event;
  },

  integrations: [
    new Sentry.Replay({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});
